import Grid from '@material-ui/core/Grid'
import AutoComplete from 'Components/AutoComplete'
import Data from 'EurestoClass/Data'
import ComboMulti from 'EurestoComponents/Utilitaire/ComboMulti/ComboMulti'
import ComboMultiBool from 'EurestoComponents/Utilitaire/ComboMulti/ComboMultiBool'
import ComboMultiEntier from 'EurestoComponents/Utilitaire/ComboMulti/ComboMultiEntier'
import ComboMultiUpload from 'EurestoComponents/Utilitaire/ComboMulti/ComboMultipleDocument'
import ComboMultiSaisieLibre from 'EurestoComponents/Utilitaire/ComboMulti/ComboMultiSaisieLibre'
import ComboSimple from 'EurestoComponents/Utilitaire/ComboSimple/ComboSimple'
import ComboSimpleBool from 'EurestoComponents/Utilitaire/ComboSimple/ComboSimpleBool'
import ComboSimpleUpload from 'EurestoComponents/Utilitaire/ComboSimple/ComboSimpleDocument'
import ComboSimpleEntier from 'EurestoComponents/Utilitaire/ComboSimple/ComboSimpleEntier'
import ComboSimpleSaisieLibre from 'EurestoComponents/Utilitaire/ComboSimple/ComboSimpleSaisieLibre'
import Date from 'EurestoComponents/Utilitaire/Other/Date'
import InputTextBasic from 'EurestoComponents/Utilitaire/Other/InputTextBasic'
import PaysNationaliteLangue from 'EurestoComponents/Utilitaire/Other/PaysNationaliteLangue'
import Picture from 'EurestoComponents/Utilitaire/Other/Picture'
import Stars from 'EurestoComponents/Utilitaire/Other/Stars'
import TextArea from 'EurestoComponents/Utilitaire/Other/TextArea'
import SaisieLibre from 'EurestoComponents/Utilitaire/SaisieLibre/SaisieLibre'
import SaisieLibreBool from 'EurestoComponents/Utilitaire/SaisieLibre/SaisieLibreBool'
import SaisieLibreUpload from 'EurestoComponents/Utilitaire/SaisieLibre/SaisieLibreDocument'
import SaisieLibreMultiple from 'EurestoComponents/Utilitaire/SaisieLibre/SaisieLibreMultiple'
import SaisieLibreMultipleBool from 'EurestoComponents/Utilitaire/SaisieLibre/SaisieLibreMultipleBool'
import SaisieLibreMultipleUpload from 'EurestoComponents/Utilitaire/SaisieLibre/SaisieLibreMultipleDocument'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import React from 'react'


class DataUtilitaire extends React.Component {

  constructor(props) {
    super(props)

    this.state =
    {
      defineData: props.defineData !== undefined ? props.defineData : false,
      data: props.data !== undefined && props.data !== null && ((props.infoTiers === true && Object.keys(props.data).length > 0 || props.infoTiers !== true)) ? props.data : undefined,
      datas: (props.defineData !== true && Constants.dataObject[props.module + '-' + props.object] && Data.list(props.module, props.object, props.search))
        || (props.defineData !== undefined && props.defineData === true ? props.objectData : []),
      type: props.type !== undefined ? props.type : Constants.typeSaisie.ComboSimple,
      object: props.object,
      title: props.title !== undefined ? props.title : undefined,
      search: props.search !== undefined ? props.search : {},
      readOnly: props.readonly !== undefined ? props.readonly : false,
      name: props.name,
      infoTiers: props.infoTiers !== undefined ? props.infoTiers : false,
      hidden: props.hidden === true,
      style: props.style,
      client_id: props.client_id,
      inputStyle: props.inputStyle,
      inline: props.inline,
      autoFocus: props.autoFocus,
      defaultHeight: props.defaultHeight
    }

    if (props.defineData !== true && Constants.dataObject[props.module + '-' + props.object] !== undefined) Data.addCbRestate(props.module, props.object, this.restate)


    this.onChangeDebounce = props.onChange
  }


  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return this.props !== nextProps || this.state !== nextState
  }

  restate = () => {
    this.setState({
      datas: Data.list(this.props.module, this.state.object, this.state.search)
    })
  }

  onChange = (e, name, event) => {
    let data = this.state.infoTiers === false ? e : (this.state.data !== undefined ? this.state.data : { id: undefined })
    if (this.state.infoTiers === true) {
      data.id = e
    }

    this.setState({
      data: data
    }, () => this.onChangeDebounce(data, this.props.name, event))
  }

  onChangeInputUpload = (val, link) => {
    let data = this.state.infoTiers === false ? val : (this.state.data !== undefined ? this.state.data : { valeur_entier: '' })
    if (this.state.infoTiers === true) {
      data.valeur_entier = val
      data.media_lien = link
    }
    this.setState({
      data: data
    }, () => this.onChangeDebounce(data, this.props.name))
  }

  onChangeInputEntier = (val) => {
    let data = this.state.infoTiers === false ? val : (this.state.data !== undefined ? this.state.data : { valeur_entier: '' })
    if (this.state.infoTiers === true) {
      data.valeur_entier = val
    }
    this.setState({
      data: data
    }, () => this.onChangeDebounce(data, this.props.name))
  }

  onChangeInput = (val) => {
    let data = this.state.infoTiers === false ? val : (this.state.data !== undefined ? this.state.data : { text: '' })
    if (this.state.infoTiers === true) {
      data.text = val
    }
    this.setState({
      data: data
    }, () => this.onChangeDebounce(data, this.props.name))
  }

  onChangeFormulaire = (o, val) => {
    let data = this.state.data
    data[o] = val
    this.setState({
      data: data
    }, () => this.onChangeDebounce(data, this.props.name))
  }

  onClickStar = (i) => {
    if (i === 1 && this.state.data === 1) {
      i = 0
    }
    this.setState({
      data: i,
      key: Utils.getRandomNumber()
    }, () => this.onChangeDebounce(i, this.props.name))

  }

  comboMultipleOption = (options, value) => {
    return options.filter(o => o.value === value || (this.state.data !== undefined ? this.state.data : []).findIndex(d => d.id === o.value) === -1)
  }

  onChangeWysiwyg = (value) => {
    this.setState({
      data: value
    }, () => this.onChangeDebounce(value, this.props.name)
    )
  }

  onChangeSaisieLibre = (e) => {
    let data = this.state.infoTiers === false ? e : (this.state.data !== undefined ? this.state.data : { text: [] })
    if (this.state.infoTiers === true) {
      data.text = e
    }
    this.setState({
      data: data
    }, this.onChangeDebounce(data, this.props.name))
  }

  //83046

  onChangeSaisieLibeMultipleBool = (e, index) => {
    let data = this.state.data !== undefined ? this.state.data : { text: [] }
    data[index].text = e
    this.setState({
      data: data
    }, this.onChangeDebounce(data, this.props.name))
  }

  onChangeSaisieLibreBool = (e) => {
    let data = this.state.data !== undefined ? this.state.data : { text: [] }
    data.text = e
    this.setState({
      data: data
    }, this.onChangeDebounce(data, this.props.name))
  }

  onChangeSaisieLibreUpload = (e, link) => {
    let data = this.state.data !== undefined ? this.state.data : { text: [] }
    data.valeur_entier = e
    data.media_lien = link
    this.setState({
      data: data
    }, this.onChangeDebounce(data, this.props.name))
  }

  onClickBoolSaisieLibreBool = () => {
    let data = this.state.data !== undefined ? this.state.data : { text: [] }
    data.valeur_bool = !(data.valeur_bool === true)
    this.setState({
      data: data
    }, this.onChangeDebounce(data, this.props.name))
  }

  onClickSaisieLibreMultipleBool = () => {
    let data = this.state.data !== undefined ? this.state.data : []
    data.push({ text: [], valeur_bool: true })
    this.setState({
      data: data,
    }, this.onChangeDebounce(data, this.props.name))
  }

  onClickRemoveSaisieLibreMultipleBool = (index) => {
    let data = this.state.data
    data.splice(index, 1)
    this.setState({
      data: data,
      key: Utils.getRandomNumber()
    }, this.onChangeDebounce(data, this.props.name))
  }

  onChangeUploadSaisieLibreMultipleUpload = (index, e, link) => {
    let data = this.state.data
    console.log(e, link)
    data[index].valeur_entier = e
    data[index].valeur_text = link
    this.setState({
      data: data
    }, this.onChangeDebounce(data, this.props.name))
  }

  onClickBoolSaisieLibreMultipleBool = (index) => {
    let data = this.state.data
    data[index].valeur_bool = !(data[index].valeur_bool === true)
    this.setState({
      data: data
    }, this.onChangeDebounce(data, this.props.name))
  }

  onChangeComboSimpleSaisieLibre = (e) => {
    let data = this.state.data !== undefined ? this.state.data : { valeur_text: [] }
    data.valeur_text = e
    this.setState({
      data: data
    }, this.onChangeDebounce(data, this.props.name))
  }

  onClickBool = () => {
    let data = this.state.data !== undefined ? this.state.data : { id: undefined }
    if (this.state.infoTiers) {
      let boolFalse = this.state.datas.find(b => b.libelle === '0' || b.libelle === 0 || b.libelle === false).id
      let boolTrue = this.state.datas.find(b => b.libelle === '1' || b.libelle === 1 || b.libelle === true).id
      data.id = data.id === boolTrue ? boolFalse : boolTrue
    } else {
      data = data === 1 || data === '1' || data === true ? 0 : 1
    }
    this.setState({
      data: data,
      key: Utils.getRandomNumber()
    }, () => this.onChangeDebounce(data, this.props.name))
  }

  onClickAddComboMultiSaisieLibre = () => {
    let data = this.state.data !== undefined ? this.state.data : []
    data.push({ id: undefined })
    this.setState({
      data: data,
    }, this.onChangeDebounce(data, this.props.name))
  }

  onClickRemoveComboMultiSaisieLibre = (index) => {
    let data = this.state.data
    data.splice(index, 1)
    this.setState({
      data: data,
      key: Utils.getRandomNumber()
    }, this.onChangeDebounce(data, this.props.name))
  }

  onChangeComboMultiSaisieLibre = (e, index) => {
    let data = this.state.data
    data[index].id = e
    this.setState({
      data: data
    }, this.onChangeDebounce(data, this.props.name))
  }

  onChangeSecondComboMultiSaisieLibre = (e, index) => {
    let data = this.state.data
    data[index].valeur_text = e
    this.setState({
      data: data
    }, this.onChangeDebounce(data, this.props.name))
  }

  onClickAddComboMultiEntier = () => {
    let data = this.state.data !== undefined ? this.state.data : []
    data.push({ id: undefined })
    this.setState({
      data: data,
    }, this.onChangeDebounce(data, this.props.name))
  }

  onClickRemoveComboMultiEntier = (index) => {
    let data = this.state.data
    data.splice(index, 1)
    this.setState({
      data: data,
      key: Utils.getRandomNumber()
    }, this.onChangeDebounce(data, this.props.name))
  }

  onChangeComboMultiEntier = (e, index) => {
    let data = this.state.data
    data[index].id = e
    this.setState({
      data: data
    }, this.onChangeDebounce(data, this.props.name))
  }

  onChangeInputComboMultiEntier = (val, index) => {
    let data = this.state.data
    data[index].valeur_entier = val
    this.setState({
      data: data
    }, () => this.onChangeDebounce(data, this.props.name))
  }

  onChangeInputComboMultiUpload = (val, index, link) => {
    let data = this.state.data
    data[index].valeur_entier = val
    data[index].media_lien = link
    this.setState({
      data: data
    }, () => this.onChangeDebounce(data, this.props.name))
  }

  onClickAddComboMultiBool = () => {
    let data = this.state.data !== undefined ? this.state.data : []
    data.push({ id: undefined, valeur_bool: true })
    this.setState({
      data: data,
    }, this.onChangeDebounce(data, this.props.name))
  }

  onClickBoolComboMultiBool = (index) => {
    let data = this.state.data
    data[index].valeur_bool = !(data[index].valeur_bool === true)
    this.setState({
      data: data
    }, this.onChangeDebounce(data, this.props.name))
  }

  onChangeComboMultiBool = (e, index) => {
    let data = this.state.data
    data[index].id = e
    this.setState({
      data: data
    }, this.onChangeDebounce(data, this.props.name))
  }

  onClickRemoveComboMultiBool = (index) => {
    let data = this.state.data
    data.splice(index, 1)
    this.setState({
      data: data,
      key: Utils.getRandomNumber()
    }, this.onChangeDebounce(data, this.props.name))
  }

  onClickComboSimpleBool = () => {
    let data = this.state.data !== undefined ? this.state.data : { id: [] }
    data.valeur_bool = !(data.valeur_bool === true)
    this.setState({
      data: data
    }, this.onChangeDebounce(data, this.props.name))
  }

  render() {
    if (this.state.hidden === true) {
      return (<div style={{ display: 'none' }} />)
    }
    let title = this.state.title !== undefined && this.state.title !== '' ?
      <label>{this.state.title}</label> : ''
    if (this.state.infoTiers === false && this.state.defineData === false && Constants.dataObject[this.props.module + '-' + this.state.object] === undefined && this.state.type !== Constants.typeSaisie.InputTextBasic && this.state.type !== Constants.typeSaisie.Stars) {
      return (<Grid container>{title}Objet inconnu</Grid>)
    } else {
      let options
      if (this.state.type === Constants.typeSaisie.ComboSimple || this.state.type === Constants.typeSaisie.ComboSimpleSaisieLibre
        || this.state.type === Constants.typeSaisie.ComboSimpleEntier || this.state.type === Constants.typeSaisie.ComboSimpleBool
        || this.state.type === Constants.typeSaisie.ComboMulti || this.state.type === Constants.typeSaisie.ComboMultiSaisieLibre
        || this.state.type === Constants.typeSaisie.ComboMultiEntier || this.state.type === Constants.typeSaisie.ComboMultiBool
        || this.state.type === Constants.typeSaisie.AutoComplete || this.state.type === Constants.typeSaisie.ComboMultiUpload
        || this.state.type === Constants.typeSaisie.ComboSimpleUpload) {
        options = []
        let datas = this.state.datas
        if (this.props.subDataOption) {
          datas.sort((a, b) =>
            ((a[this.props.dataMere] === undefined || a[this.props.dataMere] === null) && (a.id - ((b[this.props.dataMere] === undefined || b[this.props.dataMere] === null) && b.id || b[this.props.dataMere])))
            || (a[this.props.dataMere] + (a.id / Math.pow(10, a.id.toString().length)) - ((b[this.props.dataMere] === undefined || b[this.props.dataMere] === null) && b.id || (b[this.props.dataMere] + (b.id / Math.pow(10, b.id.toString().length)))))
          )
        }
        datas.map((data, index) => {
          if (data.condition === undefined || data.condition()) {
            options.push({
              value: this.state.defineData === true
                ? data.id : data[Constants.dataObject[this.props.module + '-' + this.state.object].modifSearch],
              html: this.props.htmlOptions && this.props.htmlOptions(data) ||
                (this.state.defineData === true
                  || data[Constants.dataObject[this.props.module + '-' + this.state.object][this.props.columnOptions || 'libelle']] === undefined
                  ?
                  this.props.subDataOption &&
                  ((data[this.props.dataMere] !== undefined && data[this.props.dataMere] !== null)
                    && <span>&nbsp;&nbsp;{data[this.props.columnOptions || 'libelle']}</span>
                    || <strong>{data[this.props.columnOptions || 'libelle']}</strong>
                  )
                  || data[this.props.columnOptions || 'libelle']
                  : data[Constants.dataObject[this.props.module + '-' + this.state.object][this.props.columnOptions || 'libelle']]),
              label: this.state.defineData === true || data[Constants.dataObject[this.props.module + '-' + this.state.object][this.props.columnOptions || 'libelle']] === undefined
                ? this.props.subDataOption && (data[this.props.dataMere] !== undefined && data[this.props.dataMere] !== null) && ((datas.find(d => data[this.props.dataMere] === d.id) || {})[this.props.columnOptions || 'libelle'] + ' / ' + data[this.props.columnOptions || 'libelle'])
                || data[this.props.columnOptions || 'libelle'] : data[Constants.dataObject[this.props.module + '-' + this.state.object][this.props.columnOptions || 'libelle']]
            })
          }
        })
      }
      if (this.state.type === Constants.typeSaisie.ComboSimple) {
        return (
          <ComboSimple {...this.state} onChange={this.onChange} options={options} disabled={this.props.disabled} />
        )
      } else if (this.state.type === Constants.typeSaisie.ComboMulti) {
        return (
          <ComboMulti {...this.state} onChange={this.onChange} options={options} title={title}
            disabled={this.props.disabled} />
        )
      } else if (this.state.type === Constants.typeSaisie.InputTextBasic) {
        return (
          <InputTextBasic {...this.state} onChangeInput={this.onChangeInput} title={title} name={this.props.name} multiple rowsMax={3}
            disabled={this.props.disabled} inputType={this.props.inputType} />
        )
      } else if (this.state.type === Constants.typeSaisie.TextArea) {
        return (
          <TextArea {...this.state} onChangeInput={this.onChangeInput} name={this.props.name}
            disabled={this.props.disabled} />
        )

      } else if (this.state.type === Constants.typeSaisie.SaisieLibre || this.state.type === Constants.typeSaisie.SaisieLibreLink) {
        return (
          <SaisieLibre {...this.state} title={title} onChangeSaisieLibre={this.onChangeSaisieLibre}
            disabled={this.props.disabled} link={this.state.type === Constants.typeSaisie.SaisieLibreLink} />
        )
      } else if (this.state.type === Constants.typeSaisie.SaisieLibreBool) {
        return (
          <SaisieLibreBool {...this.state} onChangeSaisieLibreBool={this.onChangeSaisieLibreBool}
            onClickBoolSaisieLibreBool={this.onClickBoolSaisieLibreBool} title={title}
            disabled={this.props.disabled} />
        )
      } else if (this.state.type === Constants.typeSaisie.SaisieLibreUpload) {
        return (
          <SaisieLibreUpload {...this.state} onChangeSaisieLibreBool={this.onChangeSaisieLibreBool}
            onChangeSaisieLibreUpload={this.onChangeSaisieLibreUpload} title={title}
            disabled={this.props.disabled} />
        )
      } else if (this.state.type === Constants.typeSaisie.SaisieLibreMultipleBool) {
        return (
          <SaisieLibreMultipleBool {...this.state} disabled={this.props.disabled}
            onClickSaisieLibreMultipleBool={this.onClickSaisieLibreMultipleBool}
            onClickBoolSaisieLibreMultipleBool={this.onClickBoolSaisieLibreMultipleBool}
            onChangeSaisieLibeMultipleBool={this.onChangeSaisieLibeMultipleBool}
            onClickRemoveSaisieLibreMultipleBool={this.onClickRemoveSaisieLibreMultipleBool} />
        )
      } else if (this.state.type === Constants.typeSaisie.SaisieLibreMultipleUpload) {
        return (
          <SaisieLibreMultipleUpload {...this.state} disabled={this.props.disabled}
            onClickSaisieLibreMultipleBool={this.onClickSaisieLibreMultipleBool}
            onChangeUploadSaisieLibreMultipleUpload={this.onChangeUploadSaisieLibreMultipleUpload}
            onChangeSaisieLibeMultipleBool={this.onChangeSaisieLibeMultipleBool}
            onClickRemoveSaisieLibreMultipleBool={this.onClickRemoveSaisieLibreMultipleBool} />
        )
      } else if (this.state.type === Constants.typeSaisie.SaisieLibreMultiple || this.state.type === Constants.typeSaisie.SaisieLibreMultipleLink) {
        return (<SaisieLibreMultiple {...this.state}
          onChangeSaisieLibeMultipleBool={this.onChangeSaisieLibeMultipleBool}
          onClickSaisieLibreMultipleBool={this.onClickSaisieLibreMultipleBool}
          onClickRemoveSaisieLibreMultipleBool={this.onClickRemoveSaisieLibreMultipleBool}
          disabled={this.props.disabled}
          link={this.state.type === Constants.typeSaisie.SaisieLibreMultipleLink} />)
      } else if (this.state.type === Constants.typeSaisie.ComboSimpleSaisieLibre) {
        return (
          <ComboSimpleSaisieLibre {...this.state} onChange={this.onChange} options={options}
            onChangeComboSimpleSaisieLibre={this.onChangeComboSimpleSaisieLibre}
            disabled={this.props.disabled} />
        )
      } else if (this.state.type === Constants.typeSaisie.ComboSimpleBool) {
        return (
          <ComboSimpleBool {...this.state} onChange={this.onChange} options={options}
            onClickComboSimpleBool={this.onClickComboSimpleBool} disabled={this.props.disabled} />
        )
      } else if (this.state.type === Constants.typeSaisie.ComboSimpleEntier) {
        return (
          <ComboSimpleEntier {...this.state} onChange={this.onChange} options={options}
            onChangeInput={this.onChangeInputEntier} disabled={this.props.disabled} />
        )
      } else if (this.state.type === Constants.typeSaisie.ComboSimpleUpload) {
        return (
          <ComboSimpleUpload {...this.state} onChange={this.onChange} options={options}
            onChangeInput={this.onChangeInputUpload} disabled={this.props.disabled} />
        )
      } else if (this.state.type === Constants.typeSaisie.ComboMultiSaisieLibre) {
        return (
          <ComboMultiSaisieLibre {...this.state} options={options} comboMultipleOption={this.comboMultipleOption}
            onClickAddComboMultiSaisieLibre={this.onClickAddComboMultiSaisieLibre}
            onClickRemoveComboMultiSaisieLibre={this.onClickRemoveComboMultiSaisieLibre}
            onChangeComboMultiSaisieLibre={this.onChangeComboMultiSaisieLibre}
            onChangeSecondComboMultiSaisieLibre={this.onChangeSecondComboMultiSaisieLibre}
            disabled={this.props.disabled} />

        )
      } else if (this.state.type === Constants.typeSaisie.ComboMultiEntier) {
        return (
          <ComboMultiEntier {...this.state} options={options} comboMultipleOption={this.comboMultipleOption}
            onClickAddComboMultiEntier={this.onClickAddComboMultiEntier}
            onClickRemoveComboMultiEntier={this.onClickRemoveComboMultiEntier}
            onChangeComboMultiEntier={this.onChangeComboMultiEntier}
            onChangeInputComboMultiEntier={this.onChangeInputComboMultiEntier}
            disabled={this.props.disabled} />
        )
      } else if (this.state.type === Constants.typeSaisie.ComboMultiUpload) {
        return (
          <ComboMultiUpload {...this.state} options={options} comboMultipleOption={this.comboMultipleOption}
            onClickAddComboMultiEntier={this.onClickAddComboMultiEntier}
            onClickRemoveComboMultiEntier={this.onClickRemoveComboMultiEntier}
            onChangeComboMultiEntier={this.onChangeComboMultiEntier}
            onChangeInputComboMultiUpload={this.onChangeInputComboMultiUpload}
            disabled={this.props.disabled} />
        )
      } else if (this.state.type === Constants.typeSaisie.ComboMultiBool) {
        return (
          <ComboMultiBool {...this.state} options={options} comboMultipleOption={this.comboMultipleOption}
            onClickAddComboMultiBool={this.onClickAddComboMultiBool}
            onClickBoolComboMultiBool={this.onClickBoolComboMultiBool}
            onChangeComboMultiBool={this.onChangeComboMultiBool}
            onClickRemoveComboMultiBool={this.onClickRemoveComboMultiBool}
            disabled={this.props.disabled} />
        )
      } else if (this.state.type === Constants.typeSaisie.Picture) {
        return (<Picture {...this.props} {...this.state} title={title} onChange={this.onChange}
          disabled={this.props.disabled} />)
      } else if (this.state.type === Constants.typeSaisie.PaysNationaliteLangue) {
        return (<PaysNationaliteLangue {...this.state} title={title} onChange={this.onChange}
          disabled={this.props.disabled} />)
      } else if (this.state.type === Constants.typeSaisie.Stars) {
        return (
          <Stars {...this.state} actif={this.props.actif} onClickStar={this.onClickStar} disabled={this.props.disabled}
            contact={this.props.contact} />
        )
      } else if (this.state.type === Constants.typeSaisie.Date) {
        return (
          <Date {...this.state} onChangeFormulaire={this.onChangeFormulaire} disabled={this.props.disabled} />
        )
      } else if (this.state.type === Constants.typeSaisie.AutoComplete) {
        return (
          <AutoComplete {...this.state} disabled={this.props.disabled} title={this.props.title} onChange={this.onChangeDebounce} options={options} />)
      } else {
        return (
          <Grid container>
            {title}
            <div>Type de saisie inconnu</div>
          </Grid>
        )
      }
    }
  }
}

export default DataUtilitaire



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponents/index.js